import { LayoutDashboard, Monitor, Image as ImageIcon, ListChecks } from 'lucide-react'
import AppShell from '@meno/ui/components/layout/AppShell'
import type { MobileTab } from '@meno/ui/components/layout/MobileTabBar'
import { usePermissions } from '@meno/ui/hooks/usePermissions'
import BrandingHeader from './BrandingHeader'

// Phone-only bottom tabs: the four places an operator goes every day. Each is
// gated on the same capability as its sidebar entry; "More" (added by the bar)
// opens the drawer for everything else.
const TABS: (MobileTab & { perm: string })[] = [
  { key: 'overview', href: '/overview',         icon: LayoutDashboard, labelKey: 'nav.overview',  fallback: 'Dashboard', perm: 'dashboard:view' },
  { key: 'screens',  href: '/screens',          icon: Monitor,         labelKey: 'nav.screens',   fallback: 'Screens',   perm: 'screens:view' },
  { key: 'media',    href: '/management/media', icon: ImageIcon,       labelKey: 'nav.assetsTab', fallback: 'Assets',    perm: 'media:view' },
  { key: 'activity', href: '/activity',         icon: ListChecks,      labelKey: 'nav.activity',  fallback: 'Activity',  perm: 'dashboard:view' },
]

// Signage uses the shared "panel" shell, but swaps the default TopBar for its
// BrandingHeader (TopBar + What's-New control). All layout / dark-panel styling
// lives in the shared shell + `.app-shell-dark` in src/index.css.
export default function SignageAppShell() {
  const { can } = usePermissions()
  return <AppShell header={<BrandingHeader />} mobileTabs={TABS.filter(tab => can(tab.perm))} />
}
